// A clip's render for hosts without a warp engine (ClipData.render), as a
// small status icon: a spinner while it is being made, a check once it is
// ready. Nothing for a clip that has none.

import { Check, Loader2 } from "lucide-react";

import { cn } from "@web-shared/lib/utils";

const TEXT = {
  pending: "Rendering this clip's warp for Live and Audiotool",
  ready: "Rendered: Live and Audiotool play this clip's warp as it sounds here",
} as const;

export function RenderStatus({ status, className }: { status: "pending" | "ready" | undefined; className?: string }) {
  if (!status) return null;
  const Icon = status === "pending" ? Loader2 : Check;
  return (
    <span role="img" aria-label={TEXT[status]} title={TEXT[status]} className={cn("inline-flex shrink-0", className)}>
      <Icon aria-hidden className={cn("size-3", status === "pending" && "animate-spin")} />
    </span>
  );
}
